import React from 'react';
import { IconBase } from '../Base';
export const IconYER = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746429C2.44194 20.7435 6.84046 24 12 24Z", fill: "black" }),
    React.createElement("path", { d: "M12 0C6.84046 0 2.44195 3.2565 0.746429 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0Z", fill: "#D80027" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_9411" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=YER.js.map